module.exports = __webpack_public_path__ + "static/img/205.6e52623.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210427/205.jpg
// module id = V/gW
// module chunks = 0